import uniq from 'lodash/fp/uniq'
import { BulkAction } from './types'

export function allIds(
  bulkAction: Pick<
    BulkAction,
    'requestedIds' | 'completedIds' | 'failedIds' | 'skippedIds'
  >
): Array<string> {
  return uniq(
    [
      ...bulkAction.requestedIds,
      ...bulkAction.completedIds,
      ...bulkAction.skippedIds,
      ...bulkAction.failedIds
    ].sort()
  )
}

export function allCompletedIds(
  bulkAction: Pick<BulkAction, 'completedIds' | 'failedIds' | 'skippedIds'>
): Array<string> {
  return uniq(
    [
      ...bulkAction.completedIds,
      ...bulkAction.failedIds,
      ...bulkAction.skippedIds
    ].sort()
  )
}

export function allSuccessfulIds(
  bulkAction: Pick<BulkAction, 'completedIds'>
): Array<string> {
  return uniq([...bulkAction.completedIds].sort())
}

export function allFailedIds(
  bulkAction: Pick<BulkAction, 'failedIds'>
): Array<string> {
  return uniq([...bulkAction.failedIds].sort())
}

export function hasPendingIds(
  bulkAction: Pick<
    BulkAction,
    'requestedIds' | 'completedIds' | 'failedIds' | 'skippedIds'
  >
): boolean {
  const allIdsCount = allIds(bulkAction).length
  const completedIdsCount = allCompletedIds(bulkAction).length
  return allIdsCount > completedIdsCount
}

export function isOlderThanMinutes(
  createdAt: string,
  minutes: number
): boolean {
  const createdDate = new Date(createdAt)
  const now = new Date()
  const diffInMilliseconds = now.getTime() - createdDate.getTime()
  const diffInMinutes = diffInMilliseconds / (1000 * 60)
  return diffInMinutes >= minutes
}

export function canCancelBulkAction(
  bulkAction: Pick<
    BulkAction,
    'createdAt' | 'requestedIds' | 'completedIds' | 'failedIds' | 'skippedIds'
  >
): boolean {
  return (
    isOlderThanMinutes(bulkAction.createdAt, 5) && hasPendingIds(bulkAction)
  )
}

export function bulkActionsRelatedToId(
  bulkActions: BulkAction[],
  id: string
): BulkAction[] {
  return bulkActions.filter(bulkAction => allIds(bulkAction).includes(id))
}
